import DialogUtils from "../../js/util/DialogUtils.js";
import {safeText} from "../../js/util/CommonUtils.js";
import {getOpenInNewIcon} from "../../js/util/IconUtils.js";

export default class EventDialogHtml{
    /** @type {HTMLDialogElement}  */
    #dialog

    /** @param {MoleculeEvent} mEvt */
    show(mEvt) {
        this.#dialog = document.body.insertAdjacentElement("beforeend", this.#createDialogElement(mEvt));
        this.#addListeners(mEvt);
        this.#dialog.showModal();
        this.#getCancelBtn().focus();
    }

    remove() {
        this.#dialog.remove();
    }

    /** @param {MoleculeEvent} mEvt */
    #addListeners(mEvt) {
        DialogUtils.setDefaultDialogListeners(this.#dialog);
        this.#dialog.addEventListener('cancel', this.remove.bind(this));
        const copySmileLink = this.#dialog.querySelector('[name="event-dialog__copy-smiles-btn"]');
        if (copySmileLink){
            copySmileLink.addEventListener('click', ()=>{
                navigator.clipboard.writeText(mEvt.originalStructure)
            })
        }
    }

    #getCancelBtn(){
        return this.#dialog.querySelector('[data-action="cancel"]')
    }

    /**
     * @param {MoleculeEvent} mEvt
     * @returns {HTMLDialogElement}
     */
    #createDialogElement(mEvt) {
        const el = document.createElement("dialog");
        el.classList.add('event-dialog');
        el.innerHTML = this.#template(mEvt);
        return el;
    }

    #getValueTemplate(value){
        let valStr = value;
        if(value == null)
            valStr = null;
        else if (typeof value === 'object' && !Array.isArray(value) && value)
            valStr = JSON.stringify(value);
        else
            valStr = value + "";
        if (valStr != null && value !== "")
            return `<span class="event-dialog__item-value">${safeText(valStr)}</span>`
        else
            return `<span class="event-dialog__item-value event-dialog__item-value--empty">Unknown</span>`
    }

    /** @param {string} propName
     * @param val
     */
    #customPropItemTemplate(propName, val){
        return `
            <div class="event-dialog__property-item">
                <span class="event-dialog__item-name event-dialog__item-name--dynamic">${safeText(propName)}:</span>
                ${this.#getValueTemplate(val)}
            </div>
        `
    }

    /**
     * @param {{}}props
     * @returns {string}
     */
    #createPropertyItems(props){
        if (!props || typeof props !== "object" || Object.keys(props).length === 0) return []
        const result = ['<div class="event-dialog__subtitle">Properties:</div>']
        for (const prop in props){
            if(prop && props[prop] != null)
                result.push(this.#customPropItemTemplate(prop, props[prop]))
        }
        return result.join('');
    }

    /**
     * @param {MoleculeEvent} mEvt
     * @returns {string} */
    #template(mEvt) {
        const originLinks = [];
        mEvt.detailsUiUrl && originLinks.push(
            `<a class="event-dialog__value-link" target="_blank" href="${safeText(mEvt.detailsUiUrl)}">UI${getOpenInNewIcon()}</a>`
        );
        mEvt.detailsApiUrl && originLinks.push(
            `<a class="event-dialog__value-link" target="_blank" href="${safeText(mEvt.detailsApiUrl)}">API${getOpenInNewIcon()}</a>`
        );
        const contextLink = mEvt.context ?
            `<a class="event-dialog__value-link" href="${window.location.origin}?context=${safeText(mEvt.context)}">${safeText(mEvt.context).substring(0, 10)}</a>` : "";

        return `
            <div class="event-dialog__content dialog-content">
                <div class="event-dialog__title">${safeText(mEvt.structureId)} was ${safeText(mEvt.eventName)}</div>
                <div class="event-dialog__body">
                    <div class="event-dialog__property-column">
                        <div class="event-dialog__property-item">
                            <span class="event-dialog__item-name">Origin:</span>
                            ${safeText(mEvt.originatingSystem)} ${originLinks.join(" ")}
                        </div>
                        <div class="event-dialog__property-item">
                            <span class="event-dialog__item-name">Happened at:</span>
                            ${this.#getValueTemplate(mEvt.happenedTimeFormatted)}
                        </div>
                        <div class="event-dialog__property-item">
                            <span class="event-dialog__item-name">Author:</span>
                            ${this.#getValueTemplate(mEvt.scientist)}
                        </div>
                        <div class="event-dialog__property-item">
                            <span class="event-dialog__item-name">Project:</span>
                            ${this.#getValueTemplate(mEvt.project)}
                        </div>
                        <div class="event-dialog__property-item">
                            <span class="event-dialog__item-name" 
                                  title="Events submitted together in the same context represent a single reaction or a single set of related molecules, depending on what we decided during the import.">
                              Find related:
                            </span>
                            ${contextLink}
                        </div>
                        ${this.#createPropertyItems(mEvt.props)}
                    </div>
                    <div class="event-dialog__image-column">
                        <div class="event-dialog__image-block">
                            <img class="event-dialog__img" src="${safeText(mEvt.structureRef)}" alt="structure" width="400">
                            <button name="event-dialog__copy-smiles-btn" class="button button--text">Copy ${safeText(mEvt.structureFormat)}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="event-dialog__buttons dialog-buttons">
                <button data-action="cancel" class="button button--text btn-cancel">Close</button>
            </div>
       `
    }
}